import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, debounceTime } from 'rxjs';
import { AuthServiceService } from './auth-service.service';

@Injectable({ providedIn: 'root' })
export class NotificationCountService {
  private notificationCountSubject = new BehaviorSubject<number>(0);
  notificationCount$ = this.notificationCountSubject.asObservable();
  
  private refreshSubject = new Subject<void>();

  constructor(private authService: AuthServiceService) {
    // 🔹 Centralized Smart Refresh
    this.refreshSubject.pipe(
      debounceTime(300) // 🛡️ Prevents redundant calls in bursts
    ).subscribe(() => {
      this.fetchTotalCount();
    });
  }

  triggerRefresh() {
    this.refreshSubject.next();
  }

  private fetchTotalCount() {
    const roleData = this.authService.getLS('role');
    if (!roleData || !this.authService.getToken) return;

    const roleId = roleData[0]; // Assuming 1: SuperAdmin, 2: Shipping, 3: Receiving

    if (roleId === '1') {
      this.authService.notificationCount().subscribe(res => this.updateState(res));
    } else if (roleId === '2') {
      this.authService.notificationShippingCount().subscribe(res => this.updateState(res));
    } else if (roleId === '3') {
      this.authService.notificationReciverCount().subscribe(res => this.updateState(res));
    }
  }

  private updateState(res: any) {
    const count = res?.result?.num_unread ?? 0;
    this.notificationCountSubject.next(count);
  }

  setCount(count: number) {
    this.notificationCountSubject.next(count);
  }

  getCount(): number {
    return this.notificationCountSubject.value;
  }
}

